module.exports = __webpack_public_path__ + "static/condo_design-6-a4d75693a06bcc12194c4735ff50e72f.jpg";